module.exports = __webpack_public_path__ + "static/dedicated_support-ff3f64a62cbd1ba80e380341e4e7c305.jpg";